import { cn } from "@/lib/utils";
import { ClassAttributes, HTMLAttributes } from "react";

import { SideFooter } from "./Footer";
import { NavMenu } from "./NavMenu";

export const SideBar = ({
    className,
    ...props
}: ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement>) => {
    return (
        <aside
            className={cn(
                `sticky left-0 top-[var(--header-height)] -mt-[38px]
                mr-[var(--sidebar-margin)] flex h-[calc(100vh-120px)]
                w-[var(--sidebar-width)] flex-col justify-between gap-6`,
                className
            )}
            {...props}
        >
            <NavMenu showSubMenu />
            <SideFooter />
        </aside>
    );
};
